import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/common/alzguard_logo.png'


const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 회사 소개 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" mdi-open-in-new ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 회사 소개 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" mdi-open-in-new ")

import { useDisplay } from "vuetify";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs } = useDisplay();

const buttons = ref([
  { hash: "#azg", title: "알츠가드", value: "azg" },
  { hash: "#smt", title: "새미톡", value: "smt" },
  { hash: "#inquiry", title: "문의", value: "inquiry" },
]);

const drawer = ref(false);

const scrollToTop = () => {
  window.scroll({ top: 0, behavior: "smooth" });
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, { app: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_app_bar_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, { class: "pa-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: _imports_0,
                              width: "120",
                              height: "36",
                              onClick: scrollToTop
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                (_unref(xs))
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_app_bar_nav_icon, {
                          variant: "text",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value, (button, index) => {
                          return (_openBlock(), _createBlock(_component_v_btn, {
                            key: index,
                            to: button.hash,
                            replace: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(button.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        }), 128)),
                        _createVNode(_component_v_btn, { href: `https://www.haii.co.kr/` }, {
                          default: _withCtx(() => [
                            _hoisted_1,
                            _createVNode(_component_v_icon, { size: "90%" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
      bottom: "",
      temporary: "",
      position: "right",
      width: "150"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value, (button, index) => {
          return (_openBlock(), _createBlock(_component_v_list, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                to: button.hash
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(button.title), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "text",
              href: `https://www.haii.co.kr/`
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_v_icon, { size: "90%" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})